import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Spinner,
} from "@chakra-ui/react";

import edit_icon_dark from "assets/images/icons/edit_icon_dark.png";

import check_icon from "assets/images/icons/check_icon.png";
import cross_dark_icon from "assets/images/icons/cross_dark_icon.png";

import PasswordInput from "components/PasswordInput/PasswordInput";

import { PatchUserPassword } from "services/UserServices";
import { isNotEmpty } from "utils/ValidationUtils";

import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";

export default function ResetProfileModal(props) {
  const { isOpen, onClose } = props;

  const [oldPasswordInput, setOldPasswordInput] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState("");

  const [errorOldPassword, setErrorOldPassword] = useState("");
  const [errorNewPassword, setErrorNewPassword] = useState("");
  const [errorNewPasswordRepeat, setErrorNewPasswordRepeat] = useState("");

  const [loading, setLoading] = useState(false);

  const validateInputs = () => {
    let flag = true;

    console.log("oldPassword", oldPasswordInput);

    if (oldPasswordInput === "") {
      console.log("oldPassword zzzz", oldPasswordInput);

      setErrorOldPassword("Please enter your old password");

      flag = false;
    }

    if (newPassword === "") {
      setErrorNewPassword("Please enter your new password");

      flag = false;
    }

    if (newPasswordRepeat === "") {
      setErrorNewPasswordRepeat("Please repeat your new password");
      flag = false;
    }

    if (newPassword !== newPasswordRepeat) {
      setErrorNewPasswordRepeat("Passwords do not match");
      flag = false;
    }

    return flag;
  };

  const handleSubmit = async (e) => {
    setErrorNewPassword("");
    setErrorNewPasswordRepeat("");
    setErrorOldPassword("");

    e.preventDefault();
    const validationResult = validateInputs();

    if (!validationResult) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const formData = new FormData(e.target);

    try {
      const res = await PatchUserPassword(formData);
      console.log(res);
      setLoading(false);
      onClose();
    } catch (error) {
      console.log(error);

      if (error.response.status === 400) {
        setErrorOldPassword("Incorrect Password");
        return;
      }

      if (error.response.status === 404) {
        setErrorOldPassword("Incorrect Password");
        return;
      }

      if (error.response.status === 500) {
        setErrorOldPassword("Internal Server Error");
        setErrorNewPassword("Internal Server Error");
        setErrorNewPasswordRepeat("Internal Server Error");
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <div className="flex flex-row gap-2">
            <div className="h-6 w-6  flex flex-col justify-center ">
              <img src={edit_icon_dark} />
            </div>
            <h4>Reset Password</h4>
          </div>
          <ModalCloseButton />
        </ModalHeader>

        <form onSubmit={(e) => handleSubmit(e)}>
          <ModalBody>
            <div className="flex flex-col gap-5">
              <div>
                <p className="label">Enter Current Password</p>
                <PasswordInput
                  name="old_user_password"
                  type="text"
                  placeholder=" "
                  value={oldPasswordInput}
                  onChange={setOldPasswordInput}
                  isInvalid={errorOldPassword !== ""}
                />
                {errorOldPassword !== "" && (
                  <FormErrorMessage
                    errorMsg={errorOldPassword}
                    showContactSupport={false}
                  />
                )}
              </div>
              <div>
                <p className="label">Enter New Password</p>
                <PasswordInput
                  name="new_user_password"
                  type="text"
                  placeholder=" "
                  value={newPassword}
                  onChange={setNewPassword}
                  isInvalid={errorNewPassword !== ""}
                />
                {errorNewPassword !== "" && (
                  <FormErrorMessage
                    errorMsg={errorNewPassword}
                    showContactSupport={false}
                  />
                )}
              </div>
              <div>
                <p className="label">Repeat New Password</p>
                <PasswordInput
                  name="new_user_password_repeat"
                  type="text"
                  placeholder=" "
                  value={newPasswordRepeat}
                  onChange={setNewPasswordRepeat}
                  isInvalid={errorNewPasswordRepeat !== ""}
                />
                {errorNewPasswordRepeat !== "" && (
                  <FormErrorMessage
                    errorMsg={errorNewPasswordRepeat}
                    showContactSupport={false}
                  />
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="flex flex-row justify-end gap-2">
              <div className="h-[3.13]">
                <Button
                  sx={{ height: "3.13rem" }}
                  variant="ghost"
                  onClick={onClose}
                >
                  <img className="mr-2" src={cross_dark_icon} /> Cancel
                </Button>
              </div>

              <div className="w-[10rem] h-[3.13]">
                <Button type="submit" isDisabled={loading}>
                  {!loading ? (
                    <>
                      <img className="mr-2" alt="Tick Icon" src={check_icon} />
                      Update
                    </>
                  ) : (
                    <>{<Spinner size="sm" />}</>
                  )}
                </Button>
              </div>
            </div>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
